import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ContactService } from '../../_services/contact.service';
import { TranslateService } from 'ngx-translate-with-country';
import { PressReleaseService } from '../../_services/preleases.service';

@Component({
  selector: 'app-newsroom',
  templateUrl: './newsroom.component.html',
  styleUrls: ['./newsroom.component.scss']
})
export class NewsroomComponent implements OnInit {

  country: string;
  language: string;
  aboutText: any;
  contactLink: any;
  page: any;
  path: any;
  item: any;
  newsroom: any;
  pressRelease: any;
  news: any;
  firstItem: any;
  secondItem: any;
  p: any;
  news1: any;
  news2: any;
  
  constructor(
    private route: ActivatedRoute,
    private _contactService: ContactService,
    private translate: TranslateService,
    private _pressReleaseService: PressReleaseService,

  ) { }

  getCustomPages(country: string, language: string) {
    this._contactService.getCustomPages(country, language)
      .subscribe(
        resJSONData => {
          this.page = resJSONData[0];
          this.newsroom = resJSONData[0].newsroomBanner.path;
        },
        error => console.log('Error ::' + error)
      )
  }
  getPressRelease(country: string, language: string): void {
    this._pressReleaseService.getpressRelease(country, language)
      .subscribe(
        resultArray =>{
          this.pressRelease = resultArray;
          this.firstItem = resultArray[0];
          this.secondItem = resultArray[1];

        },
        error => console.log('Error ::' + error)
      )
  }
  getNews(country: string, language: string): void {
    this._contactService.getNews(country, language)
      .subscribe(
        resultArray =>{
          this.news = resultArray;
          this.news1 = this.news[this.news.length-2];
          this.news2 = this.news[this.news.length-1];

        },
        error => console.log('Error ::' + error)
      )
  }

  ngOnInit() {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.country = params['country'];
        this.language = params['language'];
        let homeUrl = '/' + this.country + '/' + this.language;
        this.translate.get(['CONTACTHEADING', 'SHARPHOME'])
        this.getCustomPages(this.country, this.language);
        this.getPressRelease(this.country, this.language);
        this.getNews(this.country, this.language);

      }
    )
  }

}
